export default __webpack_public_path__ + "static/media/logo192x192.79c56d04.png";